var _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 474,
    viewBox: "0 0 477 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 413.099,
    y1: 414.886,
    x2: 353.099,
    y2: 150.887,
    stroke: "#202531",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 342.792,
    y1: 153.813,
    x2: 58.7916,
    y2: 63.8131,
    stroke: "#202531",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 414,
    r: 60,
    fill: "#FDA800"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E50C33"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 150,
    r: 90,
    fill: "#0196BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGroup1);
export default __webpack_public_path__ + "static/media/dotGroup1.b16c17dab158c6ec01be34c195a98c6f.svg";
export { ForwardRef as ReactComponent };